export const getCloseButtonStyles = (customizeState) => {
    const nudgeClosed = customizeState?.nudgeClosed || {};
    const shape = nudgeClosed.shape;
    const positionMode = nudgeClosed.positionMode || "inside";

    const toNumber = (value) => {
        if (value === "" || value === null || value === undefined) {
            return null;
        }
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    };

    const width = toNumber(nudgeClosed.width) ?? 28;
    const height = toNumber(nudgeClosed.height) ?? 28;
    const padding = toNumber(nudgeClosed.padding);
    const fontSize = toNumber(nudgeClosed.fontSize);
    const topPosition = toNumber(nudgeClosed.topPosition);
    const rightPosition = toNumber(nudgeClosed.rightPosition);
    const borderWidth = toNumber(nudgeClosed.borderWidth);
    const borderRadius = toNumber(nudgeClosed.borderRadius);

    const shadowEnabled = !!nudgeClosed.shadowEnabled;
    const shadowX = toNumber(nudgeClosed.shadowX) ?? 0;
    const shadowY = toNumber(nudgeClosed.shadowY) ?? 0;
    const shadowBlur = toNumber(nudgeClosed.shadowBlur) ?? 0;
    const shadowSpread = toNumber(nudgeClosed.shadowSpread) ?? 0;
    const shadowColor = nudgeClosed.shadowColor || "rgba(0, 0, 0, 0.2)";

    let resolvedBorderRadius = borderRadius;
    if (shape === "circle" || shape === "pill") {
        resolvedBorderRadius = 999;
    } else if (shape === "square") {
        resolvedBorderRadius = 0;
    }

    const styles = {
        color: nudgeClosed.textColor,
        backgroundColor: nudgeClosed.backgroundColor,
        borderColor: nudgeClosed.borderColor,
        borderStyle: nudgeClosed.borderStyle,
        display: nudgeClosed.display || "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 1,
        zIndex: 2,
    };

    if (fontSize !== null) {
        styles.fontSize = `${fontSize}px`;
    }

    if (positionMode === "outside") {
        const baseSize = width || height || 28;
        const outsideOffset = Math.round(baseSize / 2);
        styles.top = `${-(outsideOffset)}px`;
        styles.right = `${-(outsideOffset)}px`;
    } else {
        if (topPosition !== null) {
            styles.top = `${topPosition}px`;
        }

        if (rightPosition !== null) {
            styles.right = `${rightPosition}px`;
        }
    }

    styles.width = `${width}px`;
    styles.height = `${height}px`;

    if (padding !== null) {
        styles.padding = `${padding}px`;
    }

    if (borderWidth !== null) {
        styles.borderWidth = `${borderWidth}px`;
    }

    if (resolvedBorderRadius !== null) {
        styles.borderRadius = `${resolvedBorderRadius}px`;
    }

    if (shadowEnabled) {
        styles.boxShadow = `${shadowX}px ${shadowY}px ${shadowBlur}px ${shadowSpread}px ${shadowColor}`;
    }

    return styles;
};
